import { SxProp } from '../../internal/styles/sx';
import { ResponsiveColors } from '../../themes/cobalt/types';
import { ValueOf } from '../../themes/types';

export const IMAGE_SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  AUTO: 'auto',
} as const;

export interface ImageProps extends SxProp {
  src: string;
  alt: string;
  size?: ValueOf<typeof IMAGE_SIZES>;
  inline?: boolean;
  bordered?: boolean;
  outerBorder?: boolean;
  rounded?: boolean;
  borderColor?: ResponsiveColors;
}
